import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=fad20900&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad20900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fad20900')) {
      api.createRecord('fad20900', component.options)
    } else {
      api.reload('fad20900', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=fad20900&scoped=true&", function () {
      api.rerender('fad20900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xKd6ZSFNhSps/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports